import { render, staticRenderFns } from "./massageorder.vue?vue&type=template&id=197793c2&"
import script from "./massageorder.vue?vue&type=script&lang=js&"
export * from "./massageorder.vue?vue&type=script&lang=js&"
import style0 from "./massageorder.vue?vue&type=style&index=0&id=197793c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports